import { MessageSquareIcon, PenToolIcon, CodeIcon, RocketIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface ProcessStep {
  num: string
  title: string
  desc: string
  icon: LucideIcon
  color: string
  bg: string
}

export const processSteps: ProcessStep[] = [
  { num: '01', title: 'Konzultácia', desc: 'Pochopíme váš biznis a nájdeme príležitosti pre AI.', icon: MessageSquareIcon, color: 'text-blue-600', bg: 'bg-blue-50' },
  { num: '02', title: 'Návrh', desc: 'Navrhneme architektúru a UX zamerané na konverziu.', icon: PenToolIcon, color: 'text-purple-600', bg: 'bg-purple-50' },
  { num: '03', title: 'Vývoj', desc: 'V 14-dňových šprintoch dodávame fungujúce časti.', icon: CodeIcon, color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { num: '04', title: 'Spustenie', desc: 'Nasadenie, testovanie a škálovanie vašej PWA.', icon: RocketIcon, color: 'text-amber-600', bg: 'bg-amber-50' },
]
